var map = {
	"./featured-banner.de-CH.json": 812,
	"./featured-banner.de-DE.json": 813,
	"./featured-banner.en-CA.json": 814,
	"./featured-banner.en-GB.json": 815,
	"./featured-banner.en-IN.json": 816,
	"./featured-banner.en-ME.json": 817,
	"./featured-banner.en-US.json": 818,
	"./featured-banner.es-EM.json": 819,
	"./featured-banner.es-ES.json": 820,
	"./featured-banner.fr-BE.json": 821,
	"./featured-banner.fr-CA.json": 822,
	"./featured-banner.fr-CH.json": 823,
	"./featured-banner.nl-BE.json": 824,
	"./featured-banner.nl-NL.json": 825,
	"./featured-banner.pl-PL.json": 826,
	"./featured-banner.pt-BR.json": 827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;